var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "lazy",
          rawName: "v-lazy:background-image",
          value: this.image,
          expression: "this.image",
          arg: "background-image",
        },
      ],
      staticClass: "hero",
      class: _vm.heroClass,
    },
    [
      _vm.showVideo
        ? _c(
            "div",
            { staticClass: "video" },
            [
              _c("video-embed", {
                attrs: {
                  video: this.video,
                  "loop-start": Number(this.videoLoopStart),
                  "loop-end": Number(this.videoLoopEnd),
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.showOverlay
        ? _c("div", { staticClass: "overlay", style: _vm.overlayStyle })
        : _vm._e(),
      _c("div", { staticClass: "container", style: _vm.containerStyle }, [
        _c(
          "div",
          { staticClass: "hero__content", style: _vm.textStyle },
          [_vm._t("default")],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }